import React from "react";
import { FiMapPin } from "react-icons/fi";
import { Container, IconBadge } from "./styles";
import Radio from "../Radio";
import { getReceiptTime } from "../../util/friendlyDate";
import { DeliveryType } from "../../util/deliveryType";
import { Storefront } from "@material-ui/icons";
import { formatCNPJ } from "../../util/formatCNPJ";

export default function StoreCard({ name, store = {}, selectedStore, onSelectStore, responsibleWithdrawal, showIcon, embedded }) {
    const {
        storeId,
        storeName,
        address = {},
        distance,
        operationTime,
        cnpj,
        pharmacistName,
        pharmacistRegistration,
        afe,
    } = store;
    const { street, number, neighborhood, city, uf } = address;
    const hasDistance = distance !== null && distance !== undefined && distance !== "";
    const fullAddress = formatAddress(street, number, neighborhood, city, uf);
    const formattedCnpj = cnpj ? formatCNPJ(String(cnpj)) || cnpj : null;
    const responsibleTechnicalInfo = [
        pharmacistName ? `Responsável Técnico: ${pharmacistName}` : null,
        pharmacistRegistration ? `CRF/RS: ${pharmacistRegistration}` : null,
    ].filter(Boolean).join(" | ");
    const hasAfe = afe !== null && afe !== undefined && afe !== "";
    const hasLegalInfo = formattedCnpj || responsibleTechnicalInfo || hasAfe;

    function formatMetersToKilometers(meters) {
        const parsedMeters = Number(meters);

        if (Number.isNaN(parsedMeters)) return `${meters} km`;

        const kilometers = parsedMeters / 1000;
        const formattedKilometers = kilometers.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

        return `${formattedKilometers} km`;
    }

    function formatAddress(street, number, neighborhood, city, uf) {
        const streetWithNumber = [street, number].filter(Boolean).join(", ");
        const cityWithUf = [city, uf].filter(Boolean).join(" - ");

        return [streetWithNumber, neighborhood, cityWithUf].filter(Boolean).join(", ");
    }

    function onClickCard(storeId) {
        if (onSelectStore)
            onSelectStore(storeId);
    }

    return (
        <Container selected={selectedStore} embedded={embedded} onClick={() => onClickCard(storeId)}>
            <div className="line">
                <IconBadge>
                    <Storefront style={{ fontSize: '22px' }} />
                </IconBadge>
                <div className="content">
                    <p className="description">{storeName}</p>
                    {operationTime && (
                        <p className="deadline">{getReceiptTime(operationTime, DeliveryType.RETIRAR_NA_LOJA)}</p>
                    )}
                    <div className="location-info">
                        {fullAddress && (
                            <p className="address">{fullAddress}</p>
                        )}
                        {hasDistance && (
                            <p className="distance">
                                <FiMapPin size={14} />
                                <span>{formatMetersToKilometers(distance)}</span>
                            </p>
                        )}
                    </div>
                    {hasLegalInfo && (
                        <div className="legal-info">
                            {formattedCnpj && (
                                <p>CNPJ: {formattedCnpj}</p>
                            )}
                            {responsibleTechnicalInfo && (
                                <p>{responsibleTechnicalInfo}</p>
                            )}
                            {hasAfe && (
                                <p>AFE: {afe}</p>
                            )}
                        </div>
                    )}
                    {responsibleWithdrawal?.withdrawalByThird === 'true' && (
                        <p className="withdrawal-info">
                            Retirado por {responsibleWithdrawal?.fullName}
                        </p>
                    )}
                </div>
            </div>
            {!embedded && (
                <Radio
                    id={`radio-${name}` + storeId}
                    name={`store-${name}`}
                    value={storeId}
                    checked={selectedStore}
                    onChange={(evt) => {
                        if (onSelectStore) onSelectStore(parseInt(evt.target.value));
                    }} onBlur={(evt) => {
                        if (onSelectStore) onSelectStore(parseInt(evt.target.value));
                    }}
                />
            )}

        </Container>
    )
}
